/**
 * Потолок одной пачки массового действия — ОДНО число на все экраны (AK-746).
 *
 * Зачем модуль. Ручка пакетной архивации принимает не больше 200 полей
 * (`FieldsArchiveBatchIn.field_ids`, `max_length=200`), а списки на экранах
 * грузят больше: общий экран полей докручивает страницами по 100 без предела,
 * карточка хозяйства — своими страницами. Один клик по «выбрать всё» на
 * хозяйстве в 500 полей отправлял бы пачку, которую сервер отбивает 422 —
 * человек видит «Не удалось: 422» вместо ответа, что он такого сделал.
 *
 * Копировать число по экранам нельзя: у нас уже был случай, когда одна и та
 * же величина жила в двух местах и разъехалась. Поэтому предел и его
 * объяснение словами живут здесь, а страницы их импортируют.
 *
 * Предел ОДИН на все терминальные кнопки пачки (архив, перенос в отделение,
 * восстановление), даже если конкретная ручка выдержала бы больше: панель
 * выделения с двумя разными правилами — «сюда 200, а сюда 500» — необъяснима
 * тому, кто её видит.
 */

/** Сколько полей уходит в ОДНУ пачку. Держится за `max_length` ручки. */
export const ARCHIVE_BATCH_MAX = 200;

/**
 * Обрезать выбор до предела пачки.
 *
 * Обрезаем МОЛЧА только сам список — о том, что выбор урезан, человеку
 * говорит `batchLimitNotice`. Тихо обрезать и промолчать нельзя: человек
 * нажал «выбрать всё» на 500 полях и вправе знать, почему обработалось 200.
 */
export function capBatchSelection(ids: readonly string[], max = ARCHIVE_BATCH_MAX): string[] {
  return ids.length <= max ? [...ids] : ids.slice(0, max);
}

/**
 * Объяснение предела словами — или `null`, когда объяснять нечего.
 *
 * `available` — сколько строк человек мог бы отметить (загружено на экране).
 * Текст один на все экраны: разные формулировки одного правила читаются как
 * разные правила.
 */
export function batchLimitNotice(
  selectedCount: number,
  available: number,
  max = ARCHIVE_BATCH_MAX,
): string | null {
  if (available <= max || selectedCount < max) return null;
  return `За один раз обрабатываем ${max} полей — отмечены первые ${max} из ${available}. Остальные пойдут следующей пачкой.`;
}
